"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cookie_1 = __importDefault(require("./cookie"));
exports.default = {
    getUtmTagsFromUrlOrCookie: function () {
        var searchParams = new URLSearchParams(window.location.search);
        var utmParams = Array.from(searchParams.entries()).filter(function (param) { return param[0].startsWith("utm_"); });
        if (utmParams.length > 0) {
            return utmParams;
        }
        var utmCookie = cookie_1.default.getCookie("sec_utm");
        if (utmCookie.length > 0) {
            return utmCookie.split("&").map(function (param) { return param.split("="); });
        }
        return utmParams;
    }
};
